/**
 *
 * @module addToWatchlistQuery
 *
 */

import Check from 'check-types';
import Exception from './../../services/exception/entry';
import ContentQuery from './../contentQuery';
import GraphQlPersistedQuery from './../graphQlPersistedQuery';

const InvalidArgumentException = Exception.InvalidArgumentException;

/**
 *
 * @class AddToWatchlistQuery
 * @extends {SDK.Content.ContentQuery}
 *
 */
export default class AddToWatchlistQuery extends ContentQuery {

    /**
     *
     * @param {Array<String>} contentIds
     *
     */
    constructor(contentIds) {

        const errorMessage = {
            ctor: 'AddToWatchlistQuery(contentIds)',
            get contentIds() {
                return `${this.ctor} needs Array of Strings`;
            }
        };

        Check.assert(
            Check.all(
                [
                    Check.array.of.nonEmptyString(contentIds),
                    Check.nonEmptyArray(contentIds)
                ]
            ),
            errorMessage.contentIds,
            InvalidArgumentException
        );

        const graphQlPersistedQuery = new GraphQlPersistedQuery('addToWatchList', {
            contentIds
        });

        super('watchlistPersisted', graphQlPersistedQuery);

    }

}



// WEBPACK FOOTER //
// ./src/content/watchlist/addToWatchlistQuery.js